

<template>
	<div>
		<compWrapper theme="primary" title="基本信息">
			<compFormEdit
				:formdata="getBase"
				:labelWidth="120"
				class="margin-layout"
				ref="formbase"
				v-model="formData"
			/>
			<vButtonGroup class="text-right padding-right-10">
				<vButton @click="submit" class="margin-right-10" theme="primary">保存</vButton>
				<vButton @click="close">返回</vButton>
			</vButtonGroup>
		</compWrapper>
		<vLoading loading size="large" transfer v-if="loading"></vLoading>
	</div>
</template>

<script>
import { HttpSaveAttachmentModel, HttpAttachmentModel } from "@/service/ucadm";
import mixin from '../mixin'
export default {
	mixins: [mixin],
	data() {
		return {
			loading: false,
			type: this.$route.params.type,
			id: this.$route.query.id,
			formData: {

			},
		}
	},
	created() {
		this.getDetial()
	},
	computed: {
		getBase() {
			return [
				{
					label: '模型名称',
					key: 'title',
					tag: 'vInput',
				},
				{
					label: 'Code模型代码',
					key: 'code',
					tag: 'vInput',
					formItem: {
						rules: [{
							required: true,
							message: '该信息不能为空,请填写'
						}, {
							validator(rule, value, callback) {
								if (!value || !/^\w{3,}$/ig.test(value)) {
									callback(new Error('不符合规范，必须数字字母下划线组合'));
								} else {
									callback();
								}
							}
						}]
					}
				},
				{
					label: '多语言标识符',
					key: 'langKey',
					tag: 'vInput',
					formItem: {
						rules: [{
							required: true,
							message: '该信息不能为空,请填写'
						}, {
							validator(rule, value, callback) {
								if (!value || !/^(\w+\.){2}\w+$/ig.test(value)) {
									callback(new Error('不符合xxx.xxx.xxx([项目].[模块].[属性])的格式规范'));
								} else {
									callback();
								}
							}
						}]
					}
				},
				{
					label: '附件类型',
					key: 'typeIds',
					tag: 'vSelect',
					options: this.getAttachmentTypes,
					props: {
						multiple: true,
						filterable: true,
					}
				},
				{
					label: '描述',
					key: 'remark',
					tag: 'vTextarea',
					required: false,
				},
			]
		}
	},
	methods: {
		close() {
			this.$router.push({
				name: 'attachmentmodel'
			})
		},
		//获取详情
		async getDetial() {
			if (this.type === 'add') return
			this.loading = true;
			HttpAttachmentModel({ id: this.id }).then(res => {
				const data = res.data || {};
				this.formData = data.entity;
				this.formData.typeIds = (data.rel_types || []).map(item => item.id);
				this.loading = false
			}).catch(err => {
				this.$VMessage.error(err.message)
				this.loading = false
			})
		},
		//保存数据
		async submit() {
			const valid = await this.$refs.formbase.validate()
			if (!valid) return
            this.loading = true
			HttpSaveAttachmentModel({
                ...this.formData,
                typeIds: this.formData.typeIds.toString()
            }).then(async () => {
				await this.$store.commit('ucadm/clearStore', 'attachmentModels');
				this.close();
			}).catch(err => {
				this.loading = false
				this.$VMessage.error(err.message);
			})
		},

	}
}
</script>
